/**
 * I pallet di una riga: interi più il resto, che vale **mezzo pallet** fino a
 * `sogliaPct` del pallet e **un pallet** oltre (la regola delle NDP, 01-10-2026).
 *
 * ⚠️ È la stessa regola di `composizione_carico.pallet_riga` nel backend: qui
 * serve solo a ricalcolare mentre Marina cambia i colli nel dialogo, senza
 * un'andata e ritorno a ogni tasto. La soglia arriva dal server (Impostazioni).
 */
export function palletRiga(
  colli: number | null | undefined,
  pezziPallet: number | null | undefined,
  sogliaPct: number,
): number | null {
  if (colli == null || !pezziPallet || pezziPallet <= 0) return null;
  const interi = Math.floor(colli / pezziPallet);
  const resto = colli - interi * pezziPallet;
  if (resto <= 0) return interi;
  return interi + (resto * 100 <= pezziPallet * sogliaPct ? 0.5 : 1);
}

/** «7,5» · «12» */
export function formatPallet(n: number): string {
  return n.toLocaleString("it-IT", { maximumFractionDigits: 1 });
}
